module.exports = __webpack_public_path__ + "static/media/Sodium_Borate_Buffer.4817c8e1.svg";